import { StyleSheet } from 'react-native'

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    paddingHorizontal: 16,
    alignItems: 'baseline'
  },
  price: {
    ...Fonts.type.bold,
    fontSize: Fonts.size.regular,
    marginLeft: 3,
  },
  offerPeriod: theme => ({
    fontFamily: Fonts.type.VFFont,
    color: theme.colors.textColorTwo,
    fontSize: Fonts.size.regular,
  }),
  priceReduction: {
    fontFamily: Fonts.type.VFFont,
    color: Colors.light_grey,
    fontSize: Fonts.size.regular,
    textDecorationLine: 'line-through',
    marginLeft: 10,
  },
})

export default styles
